import React from 'react';
const stats = [{
  value: '6',
  label: 'Professional Modules'
}, {
  value: '250+',
  label: 'Exercises & Movements'
}, {
  value: '100',
  label: 'Ready-to-Use Sessions'
}, {
  value: '12 Months',
  label: 'Of Programming'
}];
export function StatsBar() {
  return <section className="bg-petrol text-white px-4 sm:px-6 py-6 sm:py-8" data-id="element-197" data-mp="1od88zje13vxp">
      <div className="max-w-4xl mx-auto" data-id="element-198" data-mp="1jc2crbl5tqjf">
        <h2 className="text-center font-heading font-bold text-[10px] sm:text-xs uppercase tracking-[0.14em] text-white/60 mb-5 leading-relaxed" data-id="element-199" data-mp="1ecz7pr56jkbg">
          Built for senior fitness professionals who are done starting from zero
        </h2>

        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-y-4 gap-x-3" data-id="element-200" data-mp="15lp5zck08hvo">
          {stats.map(stat => <div key={stat.label} className="text-center lg:border-r lg:border-white/10 lg:last:border-r-0" data-id="element-201" data-mp="10ndw51tpm7dg">
              <dt className="sr-only" data-id="element-202" data-mp="qnwo4dqzjheb">{stat.label}</dt>
              <dd data-id="element-203" data-mp="qoeuw4b9xe0h">
                <span className="block font-heading font-black text-xl sm:text-3xl text-lime leading-none mb-1" data-id="element-204" data-mp="qpzg33bp7klo">
                  {stat.value}
                </span>
                <span className="block font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.12em] text-white/70 leading-snug" data-id="element-205" data-mp="3tgdjbf5fa4du">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}